import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EventTypeService } from '../../../../core/services/eventType.service';
import {TargetGroupService} from '../../../../core/services/targetGroup.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'rewards-all-modal',
    templateUrl: './rewardsToAll.modal.html',
    styleUrls: ['./rewardsToAll.modal.scss'],
    standalone: false
})

export class RewardsToAll implements OnInit {

  public eventCategories = [];
  selected;
  numberItem = 0;
  comment = '';
  targetGroups = [];
  selectedTg;
  constructor(public dialogRef: MatDialogRef<RewardsToAll>, public eventTypeService: EventTypeService,
              private targetService: TargetGroupService, public spinner: NgxSpinnerService) {

  }

  ngOnInit() {
    this.getEventType();
    this.getTargetGroups();
  }

  getEventType() {
    this.eventTypeService.getEventTypes().then((result: any) => {
      this.eventCategories = result.map((res: any) => {
        return {label: res.name, value: res.id , color: res.color};
      });
    });
  }

  getTargetGroups () {
    this.spinner.show();
    this.targetService.getTargetGroups().then((data: any) => {
      this.spinner.hide();
      this.targetGroups = data.targetGroups;
    });
  }

  add() {
    if (this.numberItem !== 0 && this.selected && this.selectedTg) {
      this.dialogRef.close({eventType: this.selected, credits: this.numberItem, comment: this.comment,
      targetGroup: this.selectedTg});
    }
  }
}
